import React, { useCallback, useEffect, useRef, useState } from "react";
import {
  Search,
  DeleteForever,
} from "@mui/icons-material";
import "devextreme/data/odata/store";

import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import { Card, Col, Container, Dropdown, Form, Modal, Pagination, Row, Table } from "react-bootstrap";
import * as yup from "yup";

import API from "../../api/api";
import { parsedUser } from "../../utils/GetCurrentUser";
import { useLocation, useParams } from "react-router-dom";
import { TextBox, DateBox } from "devextreme-react";
import FieldSelector from "../../components/customComponents/FieldSelector";
import { useFormik } from "formik";
import Sha256 from "../../utils/sha256";
import logoSignos from "../../assets/SignosFrameworkLogo.png";

import { useToast } from "../../contexts/toast";
import yupTypeValidator from "../../utils/YupTypeValidator";
import { exportToPDF as GeneratePDF } from '../../utils/export-to-pdf';
import { exportToExcel as GenerateXLS } from '../../utils/export-to-excel';
import { CustomBreadcrumbs as Breadcrumbs } from "../../components";
import useFavorite from "../../hooks/useFavorite";
import moment from "moment";
import "../../index.css";

export default function ReportSimpleV3() {  
  // PROPERTIES
  const user = parsedUser();
  const { pathname } = useLocation();
  const params = useParams();
  const { idModule } = useParams();
  const toast = useToast();

  const [recordCount, setRecordCount] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [generalError, setGeneralError] = useState(null);
  const [open, setOpen] = useState(false);
  const [actionMode, setActionMode] = useState(null);//I=Insert, U= Update = C= Consultar, D= Delete
  const [loading, setLoading] = useState(false);
  // const [isPinned, setIsPinned] = useState(false);
  const [isSearching, setIsSearching] = useState(true);
  const checkAudit = localStorage.getItem('AuditInformation')
  const [showTable, setShowTable] = useState(false); // Nuevo estado

  const initialModel = {
    section: {},
    data: {
      Columns: [],
      Rows: [],
      Summary: [],
      Alignment: [],
    },
  }
  const [section, setSection] = useState(null);
  const [fields, setFields] = useState([])
  const [filters, setFilters] = useState([]) // Filtros dinámicos del Model
  const [model, setModel] = useState(initialModel);
  const [search, setSearch] = useState(""); // Búsqueda general (string simple)
  const [columnFilters, setColumnFilters] = useState({}); // Filtros por columna (objeto)
  const [openFilterColumn, setOpenFilterColumn] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [RecordsQuantity, setRecordsQuantity] = useState(10);
  const allowedPageSizes = [{ value: 10, text: 10 }, { value: 20, text: 20 }, { value: 50, text: 50 }, { value: 100, text: 100 }, { value: 0, text: "Todos" }];
  const [selectedItem, setSelectedItem] = useState(null);
  const [selectedItemIndex, setSelectedItemIndex] = useState(null);
  const { isPinned, UpdateFavorites, checkIfPinned } = useFavorite()
  const selectedItemRef = useRef(null);
  const [sortBy, setSortBy] = useState('Id')
  const [sortByOrder, setSortByOrder] = useState('DESC')
  
  // Filter helper functions
  const updateColumnFilter = (fieldName, value) => {
    setColumnFilters(prev => ({
      ...prev,
      [fieldName]: value
    }));
  };

  const clearAllFilters = async () => {
    setSearch("");
    setColumnFilters({});
    setOpenFilterColumn(null);
    setShowTable(false); // Ocultar tabla al limpiar filtros
    setTimeout(async () => {
      await bindDataRemote(true);
      await bindDataCountRemote(true);
    }, 100);
  };

  const toggleFilterDropdown = (fieldName) => {
    setOpenFilterColumn(openFilterColumn === fieldName ? null : fieldName);
  };

  const applyColumnFilter = async () => {
    setOpenFilterColumn(null);
    await bindDataRemote();
    await bindDataCountRemote();
  };

  const clearSingleColumnFilter = async (fieldName) => {
    setColumnFilters(prev => {
      const newFilters = { ...prev };
      delete newFilters[fieldName];
      return newFilters;
    });
    setTimeout(async () => {
      await bindDataRemote();
      await bindDataCountRemote();
    }, 100);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (openFilterColumn && !event.target.closest('.position-relative')) {
        setOpenFilterColumn(null);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [openFilterColumn]);
  
  // END PROPERTIES



  //METHODS
  ///BRING THE DATA FROM THE SERVER FOR MODEL AND RECORDS
  const bindDataRemote = useCallback(async (cleanFilter) => {

    // First start loading the model
    setLoading(true);

    //First load records

    try {
      let query = `IdUser=${user.IdUser}&id=${params.id}&Token=${user.Token}${idModule ? "&IdModule=" + idModule : ""}`;
      
      // Filtrar solo los campos con valores no vacíos
      const activeFilters = Object.keys(columnFilters).reduce((acc, key) => {
        const value = columnFilters[key];
        if (value !== null && value !== undefined && value !== "") {
          acc[key] = value;
        }
        return acc;
      }, {});

      // Filtros por columna tienen prioridad sobre búsqueda general
      if (Object.keys(activeFilters).length > 0 && cleanFilter == null) {
        query += "&Search=" + encodeURIComponent(JSON.stringify(activeFilters));
      } else if (search.length > 0 && cleanFilter == null) {
        // Búsqueda general solo si no hay filtros de columna
        query += "&Search=" + search;
      }
      
      // Garantizar que RecordsQuantity sea un número
      const quantityNumber = Number(RecordsQuantity);
      let quantity = quantityNumber === 0 ? recordCount : quantityNumber;
      
      query += `&PageNumber=${currentPage}&Quantity=${quantity}&SortBy=${sortBy}&SortType=${sortByOrder}`;
      
      console.log("🔍 QUERY Records:", query);
      let prefix = idModule ? "CRUDDynamic" : "CRUD";
      let request = await API.getAction(`api/${prefix}/ReportRecords`, query);
      
      console.log("🔍 RAW Response:", request.data);
      
      // Para reportes, la respuesta puede venir directamente como array
      let dataFromAPI = [];
      let summaryFromAPI = [];
      let alignmentFromAPI = [];
      
      if (Array.isArray(request.data) && request.data.length > 0) {
        // Si viene directamente como array de objetos
        if (request.data[0].JSONData) {
          // Caso 1: Viene con JSONData wrapper
          let results = request.data[0];
          let parsedResults = JSON.parse(results.JSONData);
          console.log("📊 Parsed Results:", parsedResults);
          
          // Verificar si viene en el formato nuevo con ReportData
          if (parsedResults.ReportData && parsedResults.ReportData.Data) {
            dataFromAPI = parsedResults.ReportData.Data;
            summaryFromAPI = parsedResults.ReportData.Summary || [];
            alignmentFromAPI = parsedResults.ReportData.Alignment || [];
            console.log("📊 Caso 1A - Con ReportData.Data:", dataFromAPI);
            console.log("📊 Summary:", summaryFromAPI);
            console.log("📊 Alignment:", alignmentFromAPI);
          } else if (Array.isArray(parsedResults) && parsedResults[0]) {
            // Formato antiguo
            let recordResult = parsedResults[0].JSONData || [];
            dataFromAPI = recordResult[0] ? (recordResult[0].JSONConfig ? recordResult[0].JSONData : recordResult) : [];
            console.log("📊 Caso 1B - Formato antiguo con array:", dataFromAPI);
          } else if (parsedResults.JSONData) {
            dataFromAPI = parsedResults.JSONData;
            console.log("📊 Caso 1C - Con JSONData directo:", dataFromAPI);
          }
        } else {
          // Caso 2: Viene directamente como array (reportes)
          dataFromAPI = request.data;
          console.log("📊 Caso 2 - Array directo (reportes):", dataFromAPI);
        }
      }
      
      console.log("✅ Final dataFromAPI:", dataFromAPI);
      console.log("✅ Final summaryFromAPI:", summaryFromAPI);
      console.log("✅ Final alignmentFromAPI:", alignmentFromAPI);


      //TODO: | Use JSONConfig to show specific fields
      let gridData = null;
      let gridColumns = dataFromAPI && dataFromAPI.length > 0 ? Object.keys(dataFromAPI[0]).filter(x => !x.startsWith("Id")) : null;

      //! If grid data stays null, we use the data from the API

      let titles = ['Audit Information', 'Added by', 'Date Added', 'Modified by', 'Last Modified']

      /*setModel({
        ...model,

        data: {
          ...model.data,
          Columns: gridColumns,
          Rows: gridData || dataFromAPI,
        },
      }); */
      //debugger;
      setModel({
        ...model,
        
        data: {
          ...model.data,
          Columns: gridColumns,
          Rows: dataFromAPI,
          Summary: summaryFromAPI,
          Alignment: alignmentFromAPI,
        },
      });



    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  }, [currentPage, search, columnFilters, sortBy, sortByOrder, RecordsQuantity, params.id, idModule]);


  useEffect(() => {
    setTableHeader([])
    setSelectedItem(null);
    setSelectedItemIndex(null);
    bindDataRemote();
    bindDataCountRemote();
  }, [params.id, idModule, bindDataRemote])

  // Limpiar selección cuando cambia la página
  useEffect(() => {
    setSelectedItem(null);
    setSelectedItemIndex(null);
  }, [currentPage])

  const bindDataCountRemote = async (cleanFilter) => {

    // First start loading the model
    //setLoading(true);

    //First load records

    try {
      let query = `IdUser=${user.IdUser}&id=${params.id}&Token=${user.Token}${idModule ? "&IdModule=" + idModule : ""}`;
      
      // Filtrar solo los campos con valores no vacíos
      const activeFilters = Object.keys(columnFilters).reduce((acc, key) => {
        const value = columnFilters[key];
        if (value !== null && value !== undefined && value !== "") {
          acc[key] = value;
        }
        return acc;
      }, {});

      // Filtros por columna tienen prioridad sobre búsqueda general
      if (Object.keys(activeFilters).length > 0 && cleanFilter == null) {
        query += "&Search=" + encodeURIComponent(JSON.stringify(activeFilters));
      } else if (search.length > 0 && cleanFilter == null) {
        // Búsqueda general solo si no hay filtros de columna
        query += "&Search=" + search;
      }
      
      console.log("🔍 QUERY RecordsCount:", query);
      let prefix = idModule ? "CRUDDynamic" : "CRUD";
      let request = await API.getAction(`api/${prefix}/RecordsCount`, query);

      console.log("🔍 RAW RecordsCount Response:", request.data);
      
      let count = 0;
      if (Array.isArray(request.data) && request.data.length > 0) {
        if (request.data[0].JSONData) {
          // Caso con JSONData wrapper
          let results = request.data[0];
          let parsedResults = JSON.parse(results.JSONData);
          console.log("📊 Parsed RecordsCount Results:", parsedResults);
          
          // Verificar si viene en el formato nuevo con ReportData
          if (parsedResults.ReportData?.Count !== undefined) {
            count = parsedResults.ReportData.Count;
            console.log("📊 RecordsCount - Con ReportData.Count:", count);
          } else if (parsedResults[0]?.JSONData?.Count !== undefined) {
            count = parsedResults[0].JSONData.Count;
            console.log("📊 RecordsCount - Formato antiguo con Count:", count);
          } else if (parsedResults.Count !== undefined) {
            count = parsedResults.Count;
            console.log("📊 RecordsCount - Count directo en parsedResults:", count);
          } else {
            count = request.data[0].Count || 0;
            console.log("📊 RecordsCount - Count en data[0]:", count);
          }
        } else {
          // Caso directo
          count = request.data[0].Count || 0;
          console.log("📊 RecordsCount - Directo:", count);
        }
      }
      
      setRecordCount(count);
      console.log("✅ Final Record Count:", count)


    } catch (error) {
      console.error(error);
    } finally {
      // setLoading(false);
    }
  };

  const bindDataModelRemote = async (cleanFilter) => {


    try {

      let prefix = idModule ? "CRUDDynamic" : "CRUD";

      //Now let's load sections
      let querySections = `IdUser=${user.IdUser}&id=${params.id}&Token=${user.Token}${idModule ? "&IdModule=" + idModule : ""}`;
      let requestSections = await API.getAction(`api/${prefix}/Model`, querySections);
      
      console.log("🔍 RAW Model Response:", requestSections.data);
      
      let recordResultSection = null;
      
      if (Array.isArray(requestSections.data) && requestSections.data.length > 0) {
        if (requestSections.data[0].JSONData) {
          // Caso con JSONData wrapper
          let resultsSections = requestSections.data[0];
          let parsedResultsSections = JSON.parse(resultsSections.JSONData);
          
          if (parsedResultsSections.Error || (parsedResultsSections[0] && parsedResultsSections[0].Error)) {
            alert(parsedResultsSections.Msg || parsedResultsSections[0].Msg);
            return;
          }
          
          // El Model puede venir en ReportData o en JSONData
          recordResultSection = parsedResultsSections.ReportData || parsedResultsSections[0]?.JSONData || parsedResultsSections;
          console.log("📊 Model - Con wrapper:", recordResultSection);
        } else {
          // Caso directo
          recordResultSection = requestSections.data;
          console.log("📊 Model - Directo:", recordResultSection);
        }
      }

      //! If grid data stays null, we use the data from the API
      let titles = ['Informacion de auditoria']
      
      // Asegurarse de que recordResultSection sea un objeto, no un array
      let sectionData = Array.isArray(recordResultSection) ? recordResultSection[0] : recordResultSection;
      
      console.log("✅ Final Section Data:", sectionData);
      
      if (sectionData) {
        // Asegurar que sectionData tenga al menos los campos básicos
        const completeSection = {
          FormTitle: sectionData.FormTitle || sectionData.ReportTitle || "Reporte",
          FormPath: sectionData.FormPath || "Reportes",
          FormIcon: sectionData.FormIcon || "fa fa-file",
          Type: sectionData.Type || "report",
          ...sectionData
        };
        
        setSection(completeSection);
        console.log("✅ Section configurado:", completeSection);
        
        if (sectionData.Fields) {
          setFields(sectionData.Fields.filter((item) => !titles.includes(item.FieldTitle)));
          console.log("✅ Fields configurados:", sectionData.Fields.length);
        }
        
        // Cargar filtros dinámicos si existen
        if (sectionData.Filters && sectionData.Filters.length > 0) {
          setFilters(sectionData.Filters);
          console.log("✅ Filtros cargados:", sectionData.Filters);
          
          // Inicializar columnFilters con los DefaultValue de cada filtro
          const initialFilters = {};
          sectionData.Filters.forEach(filter => {
            if (filter.DefaultValue !== undefined && filter.DefaultValue !== null && filter.DefaultValue !== "") {
              initialFilters[filter.FieldName] = filter.DefaultValue;
              console.log(`✅ Filtro ${filter.FieldName} inicializado con DefaultValue:`, filter.DefaultValue);
            }
          });
          
          if (Object.keys(initialFilters).length > 0) {
            setColumnFilters(initialFilters);
            console.log("✅ columnFilters inicializados con DefaultValues:", initialFilters);
          }
        } else {
          setFilters([]);
          console.log("⚠️ No hay filtros definidos en el modelo");
        }
      } else {
        console.error("❌ No se pudo obtener sectionData del Model");
      }

    } catch (error) {
      console.error(error);
    } finally {
      //  setLoading(false);
    }
  };
  const [formSize, setFormSize] = useState('md');
  const [tableHeader, setTableHeader] = useState([]);
  useEffect(() => {

  })
  const bindDataHeaderRemote = async (cleanFilter) => {


    try {

      let prefix = idModule ? "CRUDDynamic" : "CRUD";

      //Now let's load sections
      let querySections = `IdUser=${user.IdUser}&id=${params.id}&Token=${user.Token}${idModule ? "&IdModule=" + idModule : ""}`;
      let requestSections = await API.getAction(`api/${prefix}/Header`, querySections);
      
      console.log("🔍 RAW Header Response:", requestSections.data);
      
      let recordResultSection = null;
      
      if (Array.isArray(requestSections.data) && requestSections.data.length > 0) {
        if (requestSections.data[0].JSONData) {
          // Caso con JSONData wrapper
          let resultsSections = requestSections.data[0];
          let parsedResultsSections = JSON.parse(resultsSections.JSONData);
          
          console.log("📊 Header parsedResults:", parsedResultsSections);
          
          if (parsedResultsSections.Error || (parsedResultsSections[0] && parsedResultsSections[0].Error)) {
            alert(parsedResultsSections.Msg || parsedResultsSections[0].Msg);
            return;
          }
          
          recordResultSection = parsedResultsSections.ReportData || parsedResultsSections[0]?.JSONData || parsedResultsSections;
          console.log("📊 Header - Con wrapper:", recordResultSection);
        } else {
          // Caso directo
          recordResultSection = requestSections.data;
          console.log("📊 Header - Directo:", recordResultSection);
        }
      }

      //! If grid data stays null, we use the data from the API
      let titles = ['Informacion de auditoria']
      
      // Asegurarse de que recordResultSection sea un objeto/array
      let headerData = Array.isArray(recordResultSection) ? recordResultSection[0] : recordResultSection;
      
      console.log("✅ Final Header Data:", headerData);
      
      if (headerData) {
        setFormSize(headerData.FormSize ?? 'md');
        
        if (headerData.Fields) {
          setTableHeader(headerData.Fields);
          console.log("✅ Table Header Fields:", headerData.Fields);
        }
      }

    } catch (error) {
      console.error(error);
    } finally {
      //  setLoading(false);
    }
  };

  useEffect(() => { 
    if (checkAudit !== null) {
      bindDataRemote();
    }
  }, [checkAudit, bindDataRemote])

  const bindDataDetailsRemote = async (recordId) => {
    //First load records
    try {
      let prefix = idModule ? "CRUDDynamic" : "CRUD";
      let query = `IdUser=${user.IdUser}&id=${params.id}&Token=${user.Token}&RecordId=${recordId}${idModule ? "&IdModule=" + idModule : ""}`;
      let request = await API.getAction(`api/${prefix}/Details`, query);
      let results = request.data[0];

      let parsedResults = JSON.parse(results.JSONData)[0];
      if (parsedResults.Error) {
        alert(parsedResults.Msg);
        return;
      }

      let finalResult = parsedResults.JSONData;
      fillFormikObject(finalResult);
      setSelectedItem(null);
      setSelectedItemIndex(null);
    } catch (error) {
      console.error(error)
    }
    //Fill object with new values
  };

  //Open edit/add mode
  const toggleOpen = async (action, reload) => {
    setActionMode(action);

    if (action === null) {
      setSelectedItem(null);
      setSelectedItemIndex(null);
      formik.resetForm();
    }

    if (action === "I") {
      setSelectedItem(null);
      setSelectedItemIndex(null);
    }
    if (action === "U" || action === "C" || action === "D") {
      setOpen(!open);

      await bindDataDetailsRemote(selectedItem.GUID);
    }

    if (selectedItemRef.current) {
      selectedItemRef.current.clearSelection();
    }

    setGeneralError(null);
    setOpen(!open);
    if (reload) {
      bindDataRemote();
    }
  };

  //Delete the record
  const deleteConfirm = async (obj) => {
    confirmAlert({
      closeOnClickOutside: false,
      message: "Seguro que quieres borrar este registro?",
      buttons: [
        {
          label: "Si",
          onClick: async () => {

            let prefix = idModule ? "CRUDDynamic" : "CRUD";
            let query = `IdUser=${user.IdUser}&id=${params.id}&Token=${user.Token}&RecordId=${selectedItem.GUID}${idModule ? "&IdModule=" + idModule : ""}`;
            await API.getAction(`api/${prefix}/Delete`, query);
            await bindDataRemote();
            setSelectedItem(null);
            setSelectedItemIndex(null);
          },
        },
        {
          label: "No",
        },
      ],
    });
  };

  //Update the field value on formik according to what has been updated
  const updateField = (fieldName, fieldValue) => {
    formik.setFieldValue(fieldName, fieldValue);
  };



  const [validationsSchema, setValidationSchema] = useState(null);

  const fillFormikObject = (record) => {
    //debugger;
    console.log("record", record, "model", section);
    if (
      section &&
      fields &&
      fields.length > 0
    ) {
      fields.forEach((item) => {
        console.log(
          "field name",
          item.FieldName,
          "RecordValue ",
          record[item.FieldName]
        );
        formik.setFieldValue(item.FieldName, record[item.FieldName]);
      });
    }

    //Now
  };

  const prepareFormikObject = () => {
    // console.log("Preparing formik object", section)
    let initialObject = {};
    let initialObjectValidation = {};

    if (fields) {
      fields.forEach((item) => {
        initialObject[item.FieldName] = item.value;

        if (item.Required) {
          initialObjectValidation[item.FieldName] = yupTypeValidator(item);
        }
      });
    }
    formik.initialValues = initialObject;

    console.log("initialObject", initialObject)

    setValidationSchema(yup.object(initialObjectValidation));
    //Now
  };

  //This method is to save the record we are working on
  const handleSubmit = async (obj, event) => {
    console.log("❗ ~ file: CRUDSimple.js:259 ~ handleSubmit ~ obj:", obj)
    console.log({ fields: fields })
    let actions = {
      "I": "I",
      "U": "U",
      "D": "I"
    };

    if (actionMode === "D") {
      const { GUID, Id, ...rest } = obj;
      obj = rest;
    }


    confirmAlert({
      closeOnClickOutside: false,
      message: "Estas seguro de querer guardar este registro?",
      buttons: [
        {
          label: "Si",
          onClick: async () => {
            let objSPVersion = "";
            fields.forEach((item) => {

              if (item.ReadOnly || item.HtmlType === "separator") return;

              if (item.HtmlType !== "separator") {
                objSPVersion +=
                  (objSPVersion.length > 0 ? ", " : "") + `@${item.FieldName}=`;
              }
              if (
                item.FieldType === "int" ||
                item.FieldType === "bool" ||
                item.FieldType === "bit" ||
                item.FieldType === "bigint"
              ) {
                objSPVersion +=
                  obj[item.FieldName] === undefined || obj[item.FieldName] === null
                    ? item.DefaultValue && item.DefaultValue.length > 0 ? item.DefaultValue : "null"
                    : "'" + obj[item.FieldName] + "'";

              } else if (item.HtmlType === "password") {
                let passwordEncrypted = null;
                if (obj[item.FieldName] && obj[item.FieldName].length > 0) {
                  passwordEncrypted =
                    obj["UserName"].toUpperCase() + obj[item.FieldName];
                  passwordEncrypted = Sha256.hash(passwordEncrypted);
                  ;
                }
                objSPVersion +=
                  obj[item.FieldName] === undefined
                    ? "null"
                    : "'" + passwordEncrypted + "'"
              } else
                if (item.HtmlType === 'radio') {

                  objSPVersion +=
                    obj[item.FieldName] === undefined || obj[item.FieldName] === null
                      ? item.DefaultValue && item.DefaultValue.length > 0 ? item.DefaultValue : "null"
                      : "'" + obj[item.FieldName] + "'";
                } else {
                  objSPVersion +=
                    obj[item.FieldName] === undefined || obj[item.FieldName] === null
                      ? "null"
                      : "'" + obj[item.FieldName] + "'";
                }
            });

            let queryString = `IdUser=${user.IdUser}&id=${params.id}&Token=${user.Token}&ActionMode=${actions[actionMode]}${idModule ? "&IdModule=" + idModule : ""}`;
            let queryData = {
              Data: objSPVersion,
            };

            let prefix = idModule ? "CRUDDynamic" : "CRUD";
            let request = await API.postAction(
              `api/${prefix}/AddEdit?${queryString}`,
              queryData
            );

            if (request.status === 200) {
              let response = JSON.parse(request.data[0].JSONData)[0];
              //debugger;
              if (response.Error) {
                setGeneralError(response.Msg);
                return;
              }
            }
            setGeneralError(null);
            setSelectedItem(null);
            setSelectedItemIndex(null);

            formik.resetForm();

            toast({
              type: "success",
              "message": "Registro guardado correctamente",
            })
            toggleOpen(null, true);
          },
        },
        {
          label: "No",
        },
      ],
    });


  };

  const formik = useFormik({
    initialValues: {},
    enableReinitialize: true,

    validateOnChange: false,
    validateOnBlur: false,

    validationSchema: validationsSchema,
    onSubmit: handleSubmit,
  });


  const addFavorite = async () => {

    const newFavorite = {
      icon: `${section.FormIcon}`,
      path: pathname,
      formPath: section.FormPath,
      title: section.FormTitle,
    }
    UpdateFavorites(newFavorite)

  }

  const headerWithoutAuditFields = () => {
    // Para reportes, usar Fields del Model si tableHeader está vacío
    let headers = tableHeader && tableHeader.length > 0 ? tableHeader : fields;
    
    console.log("🔍 headerWithoutAuditFields - tableHeader:", tableHeader);
    console.log("🔍 headerWithoutAuditFields - fields:", fields);
    console.log("🔍 headerWithoutAuditFields - usando:", headers);
    
    // Normalizar headers para que tengan FieldTitle (reportes usan ListTitle)
    const normalizedHeaders = headers && headers.map(header => ({
      ...header,
      FieldTitle: header.FieldTitle || header.ListTitle || header.FieldName
    }));
    
    return normalizedHeaders && normalizedHeaders
      .filter(x =>
        x.FieldTitle !== "Audit Information"
        && x.FieldName !== "Id"
        && x.FieldName !== "IdUserAdd"
        && x.FieldName !== 'DateAdd'
        && x.FieldName !== 'IdUserMod'
        && x.FieldName !== 'DateMod'
        && (x.ListVisible !== false) // Solo mostrar si ListVisible no es false
      )
  }

  // Función helper para obtener la alineación de una columna
  const getColumnAlignment = (columnName) => {
    if (!model?.data?.Alignment || model.data.Alignment.length === 0) {
      return 'left'; // Alineación por defecto
    }
    
    const alignmentItem = model.data.Alignment.find(a => a.ColumnName === columnName);
    return alignmentItem ? alignmentItem.Align : 'left';
  }

  // Función helper para convertir alignment a clase de Bootstrap justify-content para HEADERS
  // Solo respeta "right", todo lo demás (left, center, undefined) va centrado
  const getHeaderJustifyClass = (alignment) => {
    if (alignment === 'right') {
      return 'justify-content-end';
    }
    return 'justify-content-center'; // Por defecto centrado para headers
  }

  // Modified by Frandy para exportar solo las columnas visibles
  const exportToExcel = useCallback(async () => {

    const visibleColumns = headerWithoutAuditFields();
    
    const excelData = model.data.Rows && model.data.Rows.map((item) => {
      return visibleColumns.reduce((acc, column) => {
        acc[column.FieldName] = item[column.FieldName];
        return acc;
      }, {});

    });
  
    GenerateXLS(excelData, `${section.FormTitle}.xlsx`);

  }, [model.data.Rows, tableHeader, section]);

  const exportToPDF = useCallback(async () => {
    const container = document.getElementById("contentContainer");
    if (container) {
      await GeneratePDF(container, "landscape", section?.FormTitle || "Registro");
    } else {
      console.error("No se encontró el contenedor para exportar a PDF");
      alert("Error: No se puede exportar el contenido. Elemento no encontrado.");
    }
    // GeneratePDF(container);
  }, [section])

  // Add by Victor: Agrega el handlePrint para imprimir el contenido de la pantalla
  const handlePrint = useCallback(() => {
    // Crear el HTML de la tabla
    const visibleColumns = headerWithoutAuditFields();
    
    let tableHTML = `
      <!DOCTYPE html>
      <html>
        <head>
          <title>${section?.FormTitle || 'Tabla'}</title>
          <style>
            @media print {
              @page {
                margin: 1cm;
                size: landscape;
              }
            }
            body {
              font-family: Arial, sans-serif;
              margin: 20px;
            }
            h4 {
              text-align: center;
              font-weight: bold;
              margin-bottom: 20px;
            }
            table {
              width: 100%;
              border-collapse: collapse;
              border: 1px solid #000;
            }
            th {
              background-color: #6c757d;
              color: white;
              font-weight: bold;
              padding: 8px;
              border: 1px solid #000;
              text-align: left;
            }
            td {
              padding: 8px;
              border: 1px solid #000;
            }
            tr:nth-child(even) {
              background-color: #f2f2f2;
            }
          </style>
        </head>
        <body>
          <h4>${section?.FormTitle || 'Tabla'}</h4>
          <table>
            <thead>
              <tr>
                ${visibleColumns.map(column => {
                  const alignment = getColumnAlignment(column.FieldName);
                  const headerAlign = alignment === 'right' ? 'right' : 'center';
                  return `<th style="text-align: ${headerAlign};">${column.FieldTitle}</th>`;
                }).join('')}
              </tr>
            </thead>
            <tbody>
              ${model?.data?.Rows?.map((item) => {
                return `<tr>
                  ${visibleColumns.map((column) => {
                    const alignment = getColumnAlignment(column.FieldName);
                    let cellValue = '';
                    if (column.FieldType === "datetime" || column.FieldType === "date") {
                      cellValue = moment(item[column.FieldName]).format("MM/DD/YYYY");
                    } else if (typeof item[column.FieldName] === 'boolean') {
                      cellValue = item[column.FieldName] ? 'Sí' : 'No';
                    } else {
                      cellValue = item[column.FieldName] || '';
                    }
                    return `<td style="text-align: ${alignment};">${cellValue}</td>`;
                  }).join('')}
                </tr>`;
              }).join('') || ''}
            </tbody>
            ${model?.data?.Summary && model.data.Summary.length > 0 ? `
              <tfoot>
                <tr style="background-color: #e9ecef; font-weight: bold;">
                  ${visibleColumns.map((column) => {
                    const summaryItem = model.data.Summary.find(s => s.ColumnName === column.FieldName);
                    const alignment = getColumnAlignment(column.FieldName);
                    const summaryAlign = alignment === 'right' ? 'right' : 'center';
                    return `<td style="font-weight: bold; text-align: ${summaryAlign};">${summaryItem ? summaryItem.SummValue.toLocaleString('en-US') : ''}</td>`;
                  }).join('')}
                </tr>
              </tfoot>
            ` : ''}
          </table>
        </body>
      </html>
    `;

    // Crear una nueva ventana y escribir el HTML
    const printWindow = window.open('', '_blank');
    if (printWindow) {
      printWindow.document.write(tableHTML);
      printWindow.document.close();
      
      // Esperar a que se cargue el contenido y luego imprimir
      printWindow.onload = () => {
        setTimeout(() => {
          printWindow.print();
          // Cerrar la ventana después de imprimir (opcional)
          // printWindow.close();
        }, 250);
      };
    }
  }, [model?.data?.Rows, tableHeader, section])

  // END METHODS

  // UI METHODS

  // REMOVIDO: bindDataRemote ya tiene sortBy y sortByOrder en sus dependencias del useCallback
  // useEffect(() => {
  //   console.log("entro", new Date())
  //   bindDataRemote();
  // }, [sortBy, sortByOrder])

  const loadGRIDUI = () => {
    return (
      <>
      
        <Container>
          <Row className="mx-2">
            <div style={{ 
              maxHeight: '600px', 
              overflowY: 'auto', 
              position: 'relative',
              borderRadius: '0.25rem'
            }}>
            <Table hover size="xl" bordered className="border shadow-sm" >
              <thead className="table-secondary" style={{ 
                position: 'sticky', 
                top: 0, 
                zIndex: 1,
                backgroundColor: '#e9ecef',
              }}>
                <tr>
                  {headerWithoutAuditFields()
                    .map((item, index) => {
                      const alignment = getColumnAlignment(item.FieldName);
                      const justifyClass = getHeaderJustifyClass(alignment);
                      return (
                        <th key={index} className={`fw-bold`} style={{ textAlign: alignment === 'right' ? 'right' : 'center' }}>
                          <div className={`d-flex ${justifyClass} align-items-center`}>
                            <span 
                              className="clickable"
                              onClick={() => {
                                setSortBy(item.FieldName);
                                if (item.FieldName === sortBy) {
                                  if (sortByOrder === 'ASC') {
                                    setSortByOrder('DESC')
                                  } else {
                                    setSortByOrder('ASC')
                                  }
                                } else {
                                  setSortByOrder('ASC')
                                }
                              }}
                            >
                              {item.FieldTitle} 
                              {sortBy === item.FieldName && sortByOrder === 'ASC' ? 
                                <i className="fas fa-sort-up ms-1"></i> : 
                                sortBy === item.FieldName && sortByOrder === 'DESC' ? 
                                <i className="fas fa-sort-down ms-1"></i> : null
                              }
                            </span>
                          </div>
                        </th>
                      )
                    })}
                </tr>
              </thead>
              <tbody>
                {model?.data && model.data.Rows.map((item, index) => {
                  return (
                    <tr 
                      key={index} 
                      onClick={() => { 
                        setSelectedItem(item);
                        setSelectedItemIndex(index);
                      }} 
                      className={selectedItemIndex === index ? "active" : ""}
                    >
                      {headerWithoutAuditFields()
                        .map((column, index2) => {
                          const alignment = getColumnAlignment(column.FieldName);
                          
                          if (column.FieldType === "datetime" || column.FieldType === "date") {
                            return (
                              <td key={index2} className={` `} style={{ textAlign: alignment }}>{moment(item[column.FieldName]).format("MM/DD/YYYY")}</td>
                            )
                          }

                          return (
                            <td key={index2} className={` `} style={{ textAlign: alignment }}>{
                              (typeof item[column.FieldName] === 'boolean') ? <input type="checkbox" checked={item[column.FieldName]} className="" readOnly /> : item[column.FieldName]
                            }</td>
                          )
                        })}
                    </tr>
                  )
                })}
              </tbody>
              {model?.data?.Summary && model.data.Summary.length > 0 && (
                <tfoot>
                  <tr className="table-secondary fw-bold">
                    {headerWithoutAuditFields().map((column, index) => {
                      // Buscar si esta columna tiene un valor de summary
                      const summaryItem = model.data.Summary.find(s => s.ColumnName === column.FieldName);
                      const alignment = getColumnAlignment(column.FieldName);
                      const summaryAlign = alignment === 'right' ? 'right' : 'center';
                      
                      return (
                        <td key={index} className="fw-bold" style={{ textAlign: summaryAlign }}>
                          {summaryItem ? summaryItem.SummValue.toLocaleString('en-US') : ''}
                        </td>
                      );
                    })}
                  </tr>
                </tfoot>
              )}
            </Table>
            </div>

            <div className="d-flex justify-content-between align-items-center">
              {(model?.data?.Columns && model?.data?.Rows.length > 0) && (<div className="d-flex align-items-center gap-3">
                <p className="m-0 fw-bold">Total de registros:</p>
                <span 
                  className="badge border border-black d-flex align-items-center justify-content-center" 
                  style={{ 
                    fontSize: '0.875rem', 
                    height: '25px',
                    minWidth: '70px',
                    padding: '0.25rem 0.5rem', 
                    backgroundColor: '#ffffff', 
                    color: '#495057' 
                  }}
                >
                  {recordCount.toLocaleString('en-US')}
                </span>
                
                <p className="m-0">Registros por página:</p>
                <div>
                  <select
                    className="form-select form-select-sm"
                    value={RecordsQuantity}
                    onChange={(e) => {
                      const selectedValue = Number(e.target.value);
                      console.log("📊 Selected value:", selectedValue, "Type:", typeof selectedValue);
                      setRecordsQuantity(selectedValue);
                      setCurrentPage(1);
                    }}
                  >
                    {allowedPageSizes.map((item, index) => {
                      return (
                        <option key={index} value={item.value}>
                          {item.text}
                        </option>
                      );
                    }
                    )}
                  </select>
                </div>
              </div>)}
              {(model?.data?.Columns && model?.data?.Rows.length > 0) && (<Pagination className="my-0">
                <Pagination.First disabled={loading} onClick={() => setCurrentPage(1)} />
                <Pagination.Prev onClick={() => setCurrentPage(currentPage - 1)} disabled={currentPage <= 1 || loading} />
                
                {/* Lógica de paginación dinámica - Muestra 5 páginas */}
                {(() => {
                  const pages = [];
                  let startPage, endPage;
                  
                  if (totalPages <= 5) {
                    // Si hay 5 páginas o menos, mostrar todas
                    startPage = 1;
                    endPage = totalPages;
                  } else {
                    // Si hay más de 5 páginas
                    if (currentPage <= 3) {
                      // Al inicio: mostrar 1, 2, 3, 4, 5
                      startPage = 1;
                      endPage = 5;
                    } else if (currentPage >= totalPages - 2) {
                      // Al final: mostrar las últimas 5
                      startPage = totalPages - 4;
                      endPage = totalPages;
                    } else {
                      // En el medio: mostrar 2 antes y 2 después de la actual
                      startPage = currentPage - 2;
                      endPage = currentPage + 2;
                    }
                  }
                  
                  // Mostrar ellipsis al inicio si es necesario
                  if (startPage > 1) {
                    pages.push(
                      <Pagination.Item 
                        key={1}
                        disabled={loading} 
                        active={false}
                        onClick={() => setCurrentPage(1)}
                      >
                        1
                      </Pagination.Item>
                    );
                    if (startPage > 2) {
                      pages.push(<Pagination.Ellipsis key="ellipsis-start" disabled />);
                    }
                  }
                  
                  // Mostrar las páginas del rango
                  for (let i = startPage; i <= endPage; i++) {
                    pages.push(
                      <Pagination.Item 
                        key={i}
                        disabled={loading} 
                        active={currentPage === i}
                        onClick={() => setCurrentPage(i)}
                      >
                        {i}
                      </Pagination.Item>
                    );
                  }
                  
                  // Mostrar ellipsis al final si es necesario
                  if (endPage < totalPages) {
                    if (endPage < totalPages - 1) {
                      pages.push(<Pagination.Ellipsis key="ellipsis-end" disabled />);
                    }
                    pages.push(
                      <Pagination.Item 
                        key={totalPages}
                        disabled={loading} 
                        active={false}
                        onClick={() => setCurrentPage(totalPages)}
                      >
                        {totalPages}
                      </Pagination.Item>
                    );
                  }
                  
                  return pages;
                })()}
                
                <Pagination.Next disabled={currentPage >= totalPages || loading} onClick={() => setCurrentPage(currentPage + 1)} />
                <Pagination.Last disabled={loading} onClick={() => setCurrentPage(totalPages)} />
              </Pagination>)}
            </div>
            {/* {console.log("Current Page", currentPage, "Total Pages", totalPages)} */}
          </Row>
        </Container>

        {/* Add by Victor: Agrega la maquetacion del formato en PDF */}
        <Container id="contentContainer" style={{ 
            position: 'absolute', 
            left: '-9999px', 
            top: 0,
            width: '100%' // Ancho fijo para el PDF
          }}>
          <div className="mb-4 text-center">
            <img src={logoSignos} alt="Signos Framework" width={400} />
            <h3 className="fw-bold">Signos Framework SRL</h3>
            <p>Ave. Rómulo Betancourt, Esq. Dr. Fernando A. Defilló, No. 1428 · Sector Bella Vista · Santo Domingo, República Dominicana.</p>
            <p>RNC: 1234567890</p>
            <p>Fecha: {moment().format("DD/MM/YYYY")}</p>
          </div>
          <Row className="mx-2">
            <h4 className="text-center fw-bold">{section.FormTitle}</h4>

            <Table hover size="xl" bordered className="border shadow-sm" >
              <thead className="table-secondary">
                <tr>
                  {headerWithoutAuditFields()
                    .map((item, index) => {
                      const alignment = getColumnAlignment(item.FieldName);
                      return (
                        <th key={index} className={`fw-bold`} style={{ textAlign: alignment === 'right' ? 'right' : 'center' }}>
                          {item.FieldTitle}
                        </th>
                      )
                    })}
                </tr>
              </thead>
              <tbody>
                {model?.data && model.data.Rows.map((item, index) => {
                  return (
                    <tr key={index}>
                      {headerWithoutAuditFields()
                        .map((column, index2) => {
                          const alignment = getColumnAlignment(column.FieldName);
                          
                          if (column.FieldType === "datetime" || column.FieldType === "date") {
                            return (
                              <td key={index2} style={{ textAlign: alignment }}>{moment(item[column.FieldName]).format("MM/DD/YYYY")}</td>
                            )
                          }

                          return (
                            <td key={index2} style={{ textAlign: alignment }}>
                              {(typeof item[column.FieldName] === 'boolean') ? 
                                (item[column.FieldName] ? 'Sí' : 'No') : 
                                item[column.FieldName]
                              }
                            </td>
                          )
                        })}
                    </tr>
                  )
                })}
              </tbody>
              {model?.data?.Summary && model.data.Summary.length > 0 && (
                <tfoot>
                  <tr className="table-secondary fw-bold">
                    {headerWithoutAuditFields().map((column, index) => {
                      // Buscar si esta columna tiene un valor de summary
                      const summaryItem = model.data.Summary.find(s => s.ColumnName === column.FieldName);
                      const alignment = getColumnAlignment(column.FieldName);
                      const summaryAlign = alignment === 'right' ? 'right' : 'center';
                      
                      return (
                        <td key={index} className="fw-bold" style={{ textAlign: summaryAlign }}>
                          {summaryItem ? summaryItem.SummValue.toLocaleString('en-US') : ''}
                        </td>
                      );
                    })}
                  </tr>
                </tfoot>
              )}
            </Table>
          </Row>
        </Container>
      </>
    );
  };

  //EVENTS


  useEffect(() => {
    setOpen(false)
    setSelectedItem(null)
    setSelectedItemIndex(null)
    setActionMode(null)
    setGeneralError(null)
    setModel(initialModel);
    checkIfPinned();
    setIsSearching(true);
    setSearch("");
    setColumnFilters({});
    setShowTable(false); // Ocultar tabla al cambiar de reporte
    bindDataModelRemote();
    bindDataHeaderRemote();
    setCurrentPage(1);
    //bindDataRemote();

    return () => formik.resetForm();
  }, [params.id]);

  useEffect(() => {

    console.log("section updated", model)
    prepareFormikObject();
  }, [section, fields]);
  // END EVENTS
  
  // REMOVIDO: bindDataRemote ya tiene RecordsQuantity en sus dependencias del useCallback
  // useEffect(() => {
  //   console.log("entro record quantity")
  //   bindDataRemote();
  // }, [RecordsQuantity])

  useEffect(() => {
    const quantity = RecordsQuantity === 0 ? recordCount : RecordsQuantity;
    const pages = quantity > 0 ? Math.ceil(recordCount / quantity) : 1;
    console.log("Record Count", recordCount, "Records Quantity", RecordsQuantity);
    console.log("Pages calculated:", pages)
    setTotalPages(pages)
  }, [recordCount, RecordsQuantity])
  
  // Debug para ver el estado de section, fields y tableHeader
  useEffect(() => {
    console.log("🔍 Estado actual:");
    console.log("  - section:", section);
    console.log("  - fields:", fields);
    console.log("  - tableHeader:", tableHeader);
    console.log("  - model.data.Rows:", model?.data?.Rows);
  }, [section, fields, tableHeader, model]);
  
  if (!section) {
    console.log("⚠️ Section no está cargado, esperando...");
    return <></>
  }
  return (
    <React.Fragment>
      {open ?
        <Modal
          show={open}
          onHide={() => toggleOpen(null)}
          backdrop="static"
          keyboard={false}
          size={formSize}
          className={"modalRight " + formSize}
        >
          <Modal.Header closeButton>
            <Modal.Title>{section.FormTitle}</Modal.Title>
          </Modal.Header>
          <Form onSubmit={formik.handleSubmit}>
            <Modal.Body>
              <Row>
                {/* CONTENT */}
                {
                  fields.map((item, index) => {
                    return (
                      <React.Fragment key={index}>
                        <Col
                          className={
                            item.cssClasss + (!item.Visible ? " d-none" : "")
                          }
                          key={index}
                        >
                          <label className={item.HtmlType === 'separator' ? `me-2 ${(index !== 0 ? "mt-4 pt-4" : "mt-2")}  separatorTitle` : "me-2 mt-3 "}>{item.FieldTitle}
                            {item.Required ? <i className="required-asterisk ms-1 text-danger">*</i> : null}
                          </label>
                          <br />

                          <FieldSelector
                            actionMode={actionMode}
                            model={item}
                            key={index}
                            obj={formik.values}
                            // limit longitudes
                            updateField={updateField}
                            value={formik.values[item.FieldName]}
                          ></FieldSelector>
                          {formik.errors[item.FieldName] ? (
                            <div className="invalid text-sm">
                              {formik.errors[item.FieldName]}
                            </div>
                          ) : null}
                        </Col>
                      </React.Fragment>
                    );
                  })}
              </Row>

              {/* Modified by Frandy para mostrar los errores de los campos */}

               {/*
              
                {Object.values(formik.errors).length > 0 && Object.values(formik.errors).map(item => {

                  return <Row className="invalid me-2 ">{item}</Row>
                })}
            
              */}


            </Modal.Body>
            <Modal.Footer>
              <div className="d-flex gx-3 align-items-center justify-content-end">
                {Object.values(formik.errors).length > 0 && (
                  <span className="invalid me-2">
                    Por favor, verificar los errores en el formulario
                  </span>
                )}

                {generalError ? <span className="invalid me-2">
                  {generalError}
                </span> : null}
                {/* 
                    - Add by Victor: Agrega color verde al boton Guardar, rojo al de Cerrar y aumenta el tamaño de ambos.
                    - Add by Victor: Cuando se consulte un registro en ReadOnly se visualiza el botón Cerrar de color Azul.                   
                */}
                <button className={`btn ${actionMode === "C" ? "btn-primary" : "btn-cancel-hover"} me-2`} type="button" onClick={() => toggleOpen(null)} style={{ width: "155px", height: "40px" }}>{actionMode === "C" ? "Cerrar" : "Cancelar"}</button>
                {actionMode !== "C" && <button className="btn btn-success" type="button" onClick={() => [formik.submitForm()]} style={{ width: "155px", height: "40px" }}>Guardar</button>}
              </div>
            </Modal.Footer>
          </Form>
        </Modal> : null}
      
      {/* Panel de Filtros - Sección independiente arriba */}
      {isSearching && (
        <Container>
          <Breadcrumbs pathTitle={section?.FormPath} />
          <div className="row mx-0">
          <React.Fragment>
              <div className="d-flex align-items-center my-1">
                <i className={section.FormIcon + " me-3 fa-2x"}></i>
                <div className="d-flex flex-column">
                  <h5 className={"my-1"}>{section.FormTitle}

                  </h5>
                </div>
              </div>
            </React.Fragment>
            <div className="col-12">
              <Card className="mb-4">
                {/* 
                
                <Card.Header className="w-full d-flex justify-content-between align-items-center">
                  <Card.Title className="mb-0">Filtros</Card.Title>
                  <div>
                    <button
                      className="btn btn-sm btn-outline-secondary me-2"
                      type="button"
                      title="Limpiar todos los filtros"
                      onClick={clearAllFilters}
                    >
                      <i className="fa-solid fa-filter-circle-xmark me-1"></i>
                      Limpiar
                    </button>
                    <button
                      className="btn btn-sm btn-primary"
                      title="Aplicar filtros"
                      type="button"
                      onClick={async () => {
                        setShowTable(true); // Mostrar tabla cuando se busca

                        const hasFilters = Object.keys(columnFilters).some(key => 
                          columnFilters[key] !== null &&
                          columnFilters[key] !== undefined &&
                          columnFilters[key] !== ""
                        ) || (search && search.length > 0);

                        if (hasFilters) {
                          // Si hay filtros, cargar los datos
                          await bindDataRemote();
                          await bindDataCountRemote();
                        } else {
                          // Si no hay filtros, mostrar tabla vacía
                          setModel({
                            ...model,
                            data: {
                              Columns: model.data.Columns || [],
                              Rows: [],
                            },
                          });
                          setRecordCount(0);
                        }
                      }}
                    >
                      <Search className="me-1" style={{ fontSize: '1rem' }} />
                      Buscar
                    </button>
                    <button
                      className="btn btn-secondary btn-sm ms-2"
                      title="Cerrar"
                      type="button"
                      onClick={() => { setIsSearching(false) }}
                    >
                      <i className="fa-solid fa-x"></i>
                    </button>
                  </div>
                </Card.Header>
                */}
                <Card.Body className="formBackground">
                  <Row>
                    {/* Filtros dinámicos desde Model */}
                    {filters && filters.length > 0 ? (
                      filters.map((filter, index) => {
                        const filterTitle = filter.FieldTitle || filter.ListTitle || filter.FieldName;
                        // Usar DefaultValue si columnFilters no tiene valor para este campo
                        const filterValue = columnFilters[filter.FieldName] !== undefined && columnFilters[filter.FieldName] !== null && columnFilters[filter.FieldName] !== ""
                          ? columnFilters[filter.FieldName]
                          : (filter.DefaultValue || "");
                        
                        return (
                          <div key={filter.FieldName} className={filter.cssClass || filter.cssClasss || 'col-12 col-md-6'}>
                            <label className="form-label small fw-bold">
                              {filterTitle}
                              {/* Added by Victor: Elimina el icono de filtro */}
                              {/* {filterValue && filterValue.length > 0 && (
                                <i className="fa-solid fa-filter-circle-xmark ms-2 text-primary"></i>
                              )} */}
                            </label>
                            
                            {filter.HtmlType === "select" ? (
                              <FieldSelector
                                actionMode={"I"}
                                model={filter}
                                obj={columnFilters}
                                updateField={(fieldName, value) => updateColumnFilter(fieldName, value)}
                                value={filterValue}
                              />
                            ) : filter.HtmlType === "date" ? (
                              <DateBox
                                id={filter.FieldName}
                                name={filter.FieldName}
                                placeholder={filter.PlaceHolder || `Seleccione ${filterTitle}`}
                                displayFormat="dd/MM/yyyy"
                                value={filterValue ? moment(filterValue).isValid() ? moment(filterValue).toDate() : null : null}
                                onValueChanged={(e) => {
                                  const formattedDate = e.value ? moment(e.value).format('YYYY-MM-DD') : '';
                                  updateColumnFilter(filter.FieldName, formattedDate);
                                }}
                              />
                            ) : (
                              <TextBox
                                mode={"text"}
                                value={filterValue}
                                placeholder={`Filtrar por ${filterTitle}...`}
                                onValueChanged={(e) => updateColumnFilter(filter.FieldName, e.value)}
                                onEnterKey={async () => {
                                  await bindDataRemote();
                                  await bindDataCountRemote();
                                }}
                              />
                            )}
                          </div>
                        );
                      })
                    ) : (
                      null
                    )}
                  </Row>
                </Card.Body>
              </Card>
              <button
                      className="btn btn-outline-secondary me-2"
                      type="button"
                      title="Limpiar todos los filtros"
                      onClick={clearAllFilters}
                      style={{ width: '155px', height: '40px', fontSize: '1.1rem' }}
                    >
                      <i className="fa-solid fa-filter-circle-xmark me-1"></i>
                      Limpiar
                    </button>
                    <button
                      className="btn btn-primary"
                      title="Aplicar filtros"
                      type="button"
                      onClick={async () => {
                        setShowTable(true); // Mostrar tabla cuando se busca
                        setCurrentPage(1); // Reset a la primera página
                        await bindDataRemote();
                        await bindDataCountRemote();
                      }}
                      style={{ width: '155px', height: '40px', fontSize: '1.1rem' }}
                    >
                      <Search className="me-1" />
                      Consultar
                    </button>
            </div>
          </div>
        </Container>
      )}

      {/* Sección del título y tabla */}
      <Container>
        <div className="row mx-0" >
          <div className="col-12">
            <div className="d-flex flex-wrap align-items-center justify-content-end mb-2 mt-2">

              {loading ? (
                <React.Fragment>
                  <div className="">
                    <div className="w-25 mx-auto my-1" style={{ paddingTop: "" }}>
                      <div className="spinner-border" role="status">
                        <span className="visually-hidden">Cargando...</span>
                      </div>
                    </div>
                  </div>
                </React.Fragment>
              ) : null}
              <div className="w-auto d-flex align-items-center">

                {actionMode === null ? (
                  <>
                  {/*
                  
                    <button className="btn btn-sm btn-primary my-1 me-2" title="Crear" disabled={loading} onClick={() => toggleOpen("I")}>
                      <i className="fa fa-plus"></i>
                    </button>
                    <button 
                      className="btn btn-sm my-1 me-2"
                      title="Actualizar" 
                      disabled={loading} 
                      onClick={async () => {
                        await bindDataRemote();
                        await bindDataCountRemote();
                      }}
                      style={{
                        backgroundColor: '#6c757d',
                        borderColor: '#6c757d',
                        color: '#fff'
                      }}
                    >
                      <i className="fa fa-sync"></i>
                    </button>
                  */}
                    {!isSearching && (
                      <button className={`btn btn-sm my-1 me-2`} title="Buscar" onClick={() => setIsSearching(true)}>
                        <i className="fa-solid fa-magnifying-glass"></i>
                      </button>
                    )}
                  </>
                ) : null}
                {selectedItem ? (
                  <>
                  {/*
                  
                    <button className="btn btn-sm  my-1 me-2" title="Actualizar" disabled={loading} onClick={() => toggleOpen("U")} aria>
                      <i className="fa fa-pencil"></i>
                    </button>
                    <button className="btn btn-sm  my-1 me-2" title="Ver" disabled={loading} onClick={() => toggleOpen("C")}>
                      <i className="fa fa-eye"></i>
                    </button>
                  */}


                  </>
                ) : null}


                {showTable && (
                    <Dropdown>
                      <Dropdown.Toggle variant="button" id="dropdown-basic">
                        <i className="fa fa-ellipsis-v" />
                      </Dropdown.Toggle>

                      <Dropdown.Menu align="end">
                        {isPinned ? <Dropdown.Item onClick={() => { addFavorite() }}>Remover de favoritos</Dropdown.Item> : <Dropdown.Item onClick={() => { addFavorite() }}>Agregar a favoritos</Dropdown.Item>}
                        <Dropdown.Divider />
                        {selectedItem ?
                          <Dropdown.Item onClick={() => { toggleOpen('D') }}>Duplicar</Dropdown.Item> : null}


                        {actionMode === null ?
                          <Dropdown.Item onClick={() => { exportToExcel() }}>Exportar a Excel</Dropdown.Item> : null}
                        
                          <Dropdown.Item
                            onClick={() => { exportToPDF() }}>Exportar a PDF</Dropdown.Item>

                        <Dropdown.Item
                          onClick={() => { handlePrint() }}>Imprimir</Dropdown.Item>

                        <Dropdown.Divider />
                        {selectedItem ?
                          <Dropdown.Item onClick={() => deleteConfirm()}>Eliminar</Dropdown.Item> : null}
                      </Dropdown.Menu>
                    </Dropdown>
                )}

              </div>
            </div>
            {showTable && loadGRIDUI()}
          </div>
        </div>
      </Container>
    </React.Fragment>
  );
}
